import { Navigate } from 'react-router-dom';
import {
  hasInventoryModuleAccess,
  canAccessEngineeringModule,
  canAccessToolingModule,
  canAccessToolingManagement,
  canAccessAccounting,
} from './roleConstants';

export function parseStoredUser(raw) {
  if (!raw) return null;
  try {
    return typeof raw === 'string' ? JSON.parse(raw) : raw;
  } catch (e) {
    return null;
  }
}

function redirectUnless(checkFn, rawUser) {
  const user = parseStoredUser(rawUser);
  if (!user) return <Navigate to="/login" replace />;
  if (!checkFn(user)) return <Navigate to="/" replace />;
  return null;
}

export function redirectUnlessInventory(rawUser) {
  return redirectUnless(hasInventoryModuleAccess, rawUser);
}

export function redirectUnlessEngineering(rawUser) {
  return redirectUnless(canAccessEngineeringModule, rawUser);
}

export function redirectUnlessTooling(rawUser) {
  return redirectUnless(canAccessToolingModule, rawUser);
}

export function redirectUnlessToolingManagement(rawUser) {
  return redirectUnless(canAccessToolingManagement, rawUser);
}

export function redirectUnlessAccounting(rawUser) {
  return redirectUnless(canAccessAccounting, rawUser);
}
